'use es6';

import Immutable from 'immutable';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import ThinListing from 'ecosystem-marketplace-core/records/ThinListing';
import * as ActionTypes from '../actions/ActionTypes';
import { ALL_COLLECTIONS_LENGTH } from '../constants/index';
const EMPTY_MAP = Immutable.Map();
const EMPTY_SET = Immutable.Set();
export default ((state = {
  cachedItemIds: EMPTY_SET,
  collectionsById: EMPTY_MAP
}, action) => {
  const {
    cachedItemIds,
    collectionsById
  } = state;
  const {
    collectionId
  } = action.meta || {};

  switch (action.type) {
    case ActionTypes.ALL_COLLECTIONS_COLLECTION_FETCH_REQUESTED:
      {
        return Object.assign({}, state, {
          collectionsById: collectionsById.setIn([collectionId, 'requestState'], RequestStates.PENDING)
        });
      }

    case ActionTypes.ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED:
      {
        let {
          items: collectionItems
        } = action.payload;
        const collectionItemsLength = collectionItems.length;

        if (collectionItemsLength > ALL_COLLECTIONS_LENGTH) {
          const filteredCollectionItems = [];

          for (let i = 0; i < collectionItemsLength; i++) {
            if (filteredCollectionItems.length === ALL_COLLECTIONS_LENGTH) {
              break;
            }

            const item = collectionItems[i];

            if (!cachedItemIds.includes(item.id) || i >= collectionItemsLength - ALL_COLLECTIONS_LENGTH) {
              filteredCollectionItems.push(item);
            }
          }

          collectionItems = [...filteredCollectionItems];
        }

        return Object.assign({}, state, {
          cachedItemIds: cachedItemIds.union(collectionItems.map(item => item.id)),
          collectionsById: collectionsById.mergeIn([collectionId], {
            requestState: RequestStates.SUCCEEDED,
            items: collectionItems.map(item => new ThinListing(item))
          })
        });
      }

    case ActionTypes.ALL_COLLECTIONS_COLLECTION_FETCH_FAILED:
      {
        return Object.assign({}, state, {
          collectionsById: collectionsById.setIn([collectionId, 'requestState'], RequestStates.FAILED)
        });
      }

    default:
      return state;
  }
});